import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { Badge } from "react-bootstrap";
import Sidebar from "../../../components/sidebar/Sidebar";
import LoadingSpinner from "../../../components/LoadingSpinner";
import "../../../pages/accounts/view/ViewAccountPage.css";
import { MUI_TABLE } from "../../../utils/muiTableConfig";
import { Username } from "../../../utils/privacyMask";

const STATUS_COLORS = {
  pending:       '#fbbf24',
  interested:    '#4ade80',
  not_interested:'#f87171',
  dismissed:     '#6b7280',
};

export default function TrialFollowupsPage() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    axios.get(`${process.env.REACT_APP_API_URL}/trial-followups`, { headers })
      .then(r => { setRecords(Array.isArray(r.data) ? r.data : []); setLoading(false); })
      .catch(err => { setError(err.response?.data?.error || 'Failed to load trial follow-ups'); setLoading(false); });
  }, []);

  const columns = useMemo(() => [
    {
      header: 'Discord', accessorKey: 'discordUsername',
      Cell: ({ cell }) => <span style={{ fontWeight: 600 }}>{cell.getValue() ? <Username value={cell.getValue()} /> : '—'}</span>,
    },
    {
      header: 'Service', accessorKey: 'service', size: 110,
      Cell: ({ cell }) => {
        const s = cell.getValue();
        const label = s === 'three' ? 'Service Three' : s === 'four' ? 'Service Four' : (s || '—');
        return <span style={{ color: '#94a3b8' }}>{label}</span>;
      },
    },
    {
      header: 'Trial Started', accessorKey: 'trialStartedAt', size: 120,
      Cell: ({ cell }) => {
        const v = cell.getValue();
        return <span style={{ color: '#64748b' }}>{v ? new Date(Number(v)).toLocaleDateString() : '—'}</span>;
      },
    },
    {
      header: 'Trial Ended', accessorKey: 'trialEndTime', size: 120,
      Cell: ({ cell }) => {
        const v = cell.getValue();
        return <span style={{ color: '#64748b' }}>{v ? new Date(Number(v)).toLocaleDateString() : '—'}</span>;
      },
    },
    {
      header: 'Follow-up', accessorKey: 'followUpSent', size: 110,
      Cell: ({ cell }) => cell.getValue()
        ? <Badge bg="success" style={{ fontSize: '0.72rem' }}>Sent</Badge>
        : <Badge bg="secondary" style={{ fontSize: '0.72rem' }}>Pending</Badge>,
    },
    {
      header: 'Status', accessorKey: 'status', size: 130,
      Cell: ({ cell }) => {
        const s = cell.getValue();
        const c = STATUS_COLORS[s] ?? '#94a3b8';
        return <Badge bg="" style={{ background: c + '22', color: c, border: `1px solid ${c}55`, fontSize: '0.72rem' }}>{s?.replace('_', ' ') || '—'}</Badge>;
      },
    },
    {
      header: 'Feedback', accessorKey: 'feedbackReason',
      Cell: ({ cell }) => <span style={{ color: '#64748b' }}>{cell.getValue() || '—'}</span>,
    },
    {
      header: 'Responded', accessorKey: 'respondedAt', size: 130,
      Cell: ({ cell }) => {
        const v = cell.getValue();
        return <span style={{ color: '#64748b' }}>{v ? new Date(Number(v)).toLocaleDateString() : '—'}</span>;
      },
    },
  ], []);

  const table = useMaterialReactTable({
    columns,
    data: records,
    enableRowActions: false,
    ...MUI_TABLE,
  });

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <Sidebar title="Trial Follow-ups" />

      <div className="view-page">
        {error && (
          <div style={{ padding: '12px 16px', marginBottom: 20, background: 'rgba(248,113,113,0.08)', border: '1px solid rgba(248,113,113,0.2)', borderRadius: 10, color: '#f87171', fontSize: '0.875rem' }}>
            <i className="bi bi-exclamation-triangle-fill me-2" />{error}
          </div>
        )}

        <div className="view-panel">
          <div className="view-panel-header">
            <h6 className="view-panel-title">
              <i className="bi bi-cone-striped" style={{ color: '#f59e0b' }} />
              All Trial Follow-ups
            </h6>
            <span className="view-panel-count">{records.length}</span>
          </div>
          <MaterialReactTable table={table} />
        </div>
      </div>
    </>
  );
}
